import React, { useState, useEffect, useContext } from "react";
import ArrowDown from "../img/ArrowDown.svg";
import User from "../img/User.svg";
import { useNavigate } from "react-router-dom";
import api from "../../api/axiosInstance";
import { CartContext } from "../../context/CartContext";
import Sort from "../img/Sort.svg";

const AppDetailsHeader = () => {
  const { cartCount, fetchCartCount } = useContext(CartContext);
  const navigate = useNavigate();
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleDropdown = (menu) => {
    setOpenDropdown(openDropdown === menu ? null : menu);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  useEffect(() => {
    fetchCartCount();
  }, []);

  return (
    <div className="w-full h-16 flex items-center justify-between px-5 bg-[#4C3A68]">
      {/* Left Section: Logo */}
      <div className="flex">
        <span
          className="font-bold text-2xl text-white cursor-pointer"
          onClick={() => navigate("/dashboard")}
        >
          Onzitr Marketplace
        </span>
      </div>

      {/* Desktop Menu */}
      <div className="hidden sm:flex gap-2 items-center">
        {/* Desktop: Go to Cart */}
        <span
          className="cursor-pointer text-sm font-bold text-white px-3 py-1 rounded-2xl relative"
          style={{
            border: "0.5px solid #A8A8A8",
            backgroundColor: "#FFFFFF",
            color: "#9367D7",
            boxShadow: "0px 4px 4px 0px #00000040",
            backdropFilter: "blur(1px)",
            WebkitBackdropFilter: "blur(1px)",
          }}
          onClick={() => navigate("/cart")}
        >
          Go to Cart
          {cartCount > 0 && (
            <span className="absolute -top-2 -right-2 text-xs bg-[#9367D7] text-white rounded-full w-5 h-5 flex items-center justify-center">
              {cartCount}
            </span>
          )}
        </span>

        {/* Desktop: Profile */}
        <span
          className="flex items-center justify-center px-1 py-1 cursor-pointer"
          style={{
            border: "0.5px solid #A8A8A8",
            backgroundColor: "#5D4D76",
            boxShadow: "0px 4px 4px 0px #00000040",
            backdropFilter: "blur(1px)",
            WebkitBackdropFilter: "blur(1px)",
            borderRadius: "50px",
          }}
          onClick={() => navigate("/profile")}
        >
          <img src={User} alt="Profile" />
        </span>
      </div>

      {/* Mobile: Cart + Hamburger */}
      <div className="sm:hidden flex items-center gap-3 ml-auto">
        {/* Mobile: Go to Cart */}
        <span
          className="cursor-pointer text-sm font-bold text-white px-3 py-1 rounded-2xl relative"
          style={{
            border: "0.5px solid #A8A8A8",
            backgroundColor: "#FFFFFF",
            color: "#9367D7",
            boxShadow: "0px 4px 4px 0px #00000040",
            backdropFilter: "blur(1px)",
            WebkitBackdropFilter: "blur(1px)",
          }}
          onClick={() => navigate("/cart")}
        >
          Go to Cart
          {cartCount > 0 && (
            <span className="absolute -top-2 -right-2 text-xs bg-[#9367D7] text-white rounded-full w-5 h-5 flex items-center justify-center">
              {cartCount}
            </span>
          )}
        </span>

        {/* Mobile: Hamburger */}
        <button
          onClick={toggleMobileMenu}
          className="text-white focus:outline-none"
        >
          <img src={Sort} alt="Hamburger Menu" className="w-6 h-6" />
        </button>
      </div>

      {/* Mobile Menu Dropdown */}
      <div
        className={`${
          isMobileMenuOpen ? "block" : "hidden"
        } sm:hidden absolute top-16 left-0 w-full bg-[#4C3A68] text-white p-5 shadow-md`}
      >
        <div className="flex flex-col gap-4">
          {/* Mobile: Profile */}
          <div className="flex gap-2 items-center mt-4">
            <span
              className="flex items-center justify-center px-1 py-1 cursor-pointer"
              style={{
                border: "0.5px solid #A8A8A8",
                backgroundColor: "#5D4D76",
                boxShadow: "0px 4px 4px 0px #00000040",
                backdropFilter: "blur(1px)",
                WebkitBackdropFilter: "blur(1px)",
                borderRadius: "50px",
              }}
              onClick={() => navigate("/profile")}
            >
              <img src={User} alt="User" />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppDetailsHeader;
